import styled from '@emotion/styled';
import {
  AccessTimeFilledOutlined,
  CheckCircle,
  InfoOutlined,
} from '@mui/icons-material';
import { Chip } from '@mui/material';

import { VideaTextButton } from '../../../../common-components/elements/VideaButton/VideaButton';
import { VideaTypography } from '../../../../common-components/elements/VideaTypography/VideaTypography';
import {
  blueBlack400,
  blueBlack630,
  blueUltramarine500,
  green400,
  greyLight600,
  orange700,
  overlineFontFamily,
  overlineFontSize,
  overlineFontWeight,
  overlineLetterSpacing,
  transparent,
  white,
} from '../../../../theme/videa-style-tokens';

export const VideaChipFilled = styled(Chip)`
  justify-content: flex-start;
  font-family: ${overlineFontFamily};
  font-weight: ${overlineFontWeight};
  color: ${blueBlack630};
  background-color: ${transparent};
  width: fit-content;
  font-size: ${overlineFontSize};
  letter-spacing: ${overlineLetterSpacing};
  box-sizing: border-box;
  padding: 0 0.25em;

  &:hover {
    background-color: transparent;
    cursor: default;
  }

  .MuiChip-avatar {
    color: ${white};
    font-size: ${overlineFontSize};
    letter-spacing: ${overlineLetterSpacing};
    margin-right: 0.5em;
  }

  &.has-thumbnail {
    &:hover {
      background-color: ${white};
      cursor: pointer;
    }
  }

  &.matched {
    .MuiChip-label {
      color: ${blueBlack400};
    }
    .MuiChip-avatar {
      height: 1.5em;
      width: 1.5em;
    }
  }
  &.unplanned {
    background-color: ${white};

    .MuiChip-label {
      color: ${orange700};
    }
    .MuiChip-avatar {
      height: 1.5em;
      width: 1.5em;
    }
  }

  &.generic {
    &.MuiButtonBase-root.MuiChip-root {
      min-height: 2.625em;
    }
    .MuiChip-label {
      padding: 0;
    }
    .MuiAvatar-root {
      display: none;
    }
    .label {
      font-size: 0.875em;
      padding: 0.25em 0.75em;
    }
  }
  .tooth-numbers {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    gap: 0.25em;
    line-height: 1em;

    width: 12em;

    .tooth-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 0.25em;
      gap: 0.45em;
      width: 100%;
    }
    .tooth {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.875em;
      padding: 0.125em;
      background-color: ${white};
      width: 1.3em;
      height: 1.3em;
    }
  }

  &.full-chip {
    .MuiChip-label {
      margin-left: 0em;
      padding-left: 0.25em;
    }
  }

  &.condensed-chip {
    .MuiChip-label {
      margin-left: 0em;
      @media (max-width: 1300px) {
        .tooth-list {
          max-width: 10em;
          overflow: hidden;
        }
      }
    }
  }
  &.huddle-perio {
    &.MuiButtonBase-root.MuiChip-root {
      min-height: 0;
      height: fit-content;
    }
  }
  &.perio-chip {
    .MuiChip-label {
      padding-left: 0.5em;
    }
  }
`;

export const InfoOutlinedIcon = styled(InfoOutlined)`
  width: 0.65em;
  fill: ${blueBlack630};
`;

export const AccessTimeFilledOutlinedIcon = styled(AccessTimeFilledOutlined)`
  width: 1em;
  fill: ${blueBlack630};

  &.MuiSvgIcon-root {
    width: 1.25em;
    height: 1.25em;
    font-size: 1em;
  }
`;
